import React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import ClinicalVideoCardV1 from '../cards/clinicalVideo/ClinicalVideoCardV1';
import './css/contentSlider.scss';
import SessionCardV1 from '../cards/session/sessionCardV1/SessionCardV1';
import useRedirect from '../customHooks/useRedirect';
SwiperCore.use([Pagination, Navigation]);
const ContentSlider = ({
  gtmTagVariable = '',
  contentArray,
  title,
  exploreMoreClick,
  type = '',
  isCta = false,
  clickCallback
}) => {
  const { redirectTo } = useRedirect();
  return contentArray && contentArray?.length > 0 ? (
    <div
      className="w-100 cmnLandingSlideRow mt-4 mb-4 mb-md-5"
      id={title == 'Watched Videos' ? 'profile_watched_video' : 'profile_recording'}
    >
      {title && (
        <div className="d-flex justify-content-between align-items-baseline">
          <h2 className="text-black fs-2 fw-semibold">{title}</h2>
          {contentArray?.length > 2 && (
            <a
              href="javascript:void(0)"
              className={`text-primary rippleEffect fs-4 fw-medium ${gtmTagVariable}_contentSlider_explore_more`}
              onClick={exploreMoreClick}
            >
              Explore More
            </a>
          )}
        </div>
      )}
      {contentArray?.length == 1 && (
        <div
          className={`${
            isCta ? 'col-xxl-6 col-lg-6 col-md-12' : 'col-xxl-3 col-lg-4 col-md-6'
          }  col`}
        >
          {type == 'session' ? (
            <SessionCardV1
              gtmTagVariable={`${gtmTagVariable}_contentSlider`}
              data={contentArray[0]}
              click={() => {
                clickCallback && clickCallback(contentArray[0].session_id);
                redirectTo(
                  'SessionDetails',
                  contentArray[0].session_id,
                  contentArray[0].session_topic
                );
              }}
            />
          ) : (
            <ClinicalVideoCardV1
              gtmTagVariable={`${gtmTagVariable}_contentSlider`}
              data={contentArray[0]}
            />
          )}
        </div>
      )}
      {contentArray?.length > 1 && (
        <div className="cmnLndngRowSlidePrrnt">
          <Swiper
            className="cmnLndngRowSlide"
            spaceBetween={24}
            slidesPerView={3}
            loop={false}
            breakpoints={{
              1: {
                slidesPerView: 1,
                spaceBetween: 10
              },
              640: {
                slidesPerView: isCta ? 2 : 3,
                spaceBetween: 15
              },
              768: {
                slidesPerView: isCta ? 1 : 2,
                spaceBetween: 22
              },
              992: {
                slidesPerView: isCta ? 1 : 3,
                spaceBetween: 24
              },
              1400: {
                slidesPerView: isCta ? 2 : 4, //4
                spaceBetween: 26
              }
            }}
          >
            {contentArray.length > 0 &&
              contentArray.map((_video, index) => (
                <SwiperSlide key={index + 1}>
                  {type == 'session' ? (
                    <SessionCardV1
                      gtmTagVariable={`${gtmTagVariable}_contentSlider`}
                      data={_video}
                      click={() => {
                        clickCallback && clickCallback(_video.session_id);
                        redirectTo('SessionDetails', _video.session_id, _video.session_topic);
                      }}
                    />
                  ) : (
                    <ClinicalVideoCardV1
                      gtmTagVariable={`${gtmTagVariable}_contentSlider`}
                      data={_video}
                    />
                  )}
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      )}
    </div>
  ) : null;
};

export default ContentSlider;
